import React from "react";
import { Form } from "antd";
import useAuth from "../../../lib/hooks/useAuth";

export const isNonKpi = (value) => value === 1 || value === "1";

// Only the new-question section uses this item. Other sections retain Form.Item.
export default function NewQuestionItem({ rules, ...props }) {
  const { auth } = useAuth();
  // Keep format checks on supplied answers (e.g. product names stored as CSV),
  // but remove required/paired-answer checks for optional questions.
  const optionalRules = rules?.filter(rule => typeof rule !== "function").map(rule => ({
    ...rule, required: false, whitespace: false, validator: undefined,
  }));
  return <Form.Item {...props} rules={isNonKpi(auth?.user?.nonKpiUser) ? optionalRules : rules} />;
}
